import {
  CustomizationDetailsBreadToggle,
  CustomizationDetailsContainer,
  CustomizationDetailsDressingMode,
  CustomizationDetailsDressingPortion,
  CustomizationDetailsDressingPortionV2,
  CustomizationDetailsDressingWeight,
  CustomizationDetailsDressingWeightV2,
} from './components';

export const CustomizationDetails = {
  Container: CustomizationDetailsContainer,
  DressingMode: CustomizationDetailsDressingMode,
  DressingWeight: CustomizationDetailsDressingWeight,
  DressingWeightV2: CustomizationDetailsDressingWeightV2,
  DressingPortion: CustomizationDetailsDressingPortion,
  DressingPortionV2: CustomizationDetailsDressingPortionV2,
  BreadToggle: CustomizationDetailsBreadToggle,
};
